export const clientTokenName = "BUOClientToken"